<template>
  <section class="faq">
    <div class="container">
      <h2 class="faq__title title mb">Ответы на частые вопросы</h2>
      <div class="faq__wrapper">
        <div class="faq__questions faq-questions">
          <Spoiler
            v-for="(item, index) in items"
            :key="item.id"
            :item="item"
            :isActive="selectedSpoiler == index"
            @toggleSpoiler="changeSpoiler(index)"
          >
            <template #title="titleSlot">
              {{ titleSlot.item.id + 1 }}. {{ titleSlot.item.label }}
              <IconDef name="spoiler-arrow" />
            </template>
          </Spoiler>
        </div>
        <div class="faq__form faq-form">
          <div class="faq-form__wrapper">
            <h4 class="faq-form__title">
              Не нашли ответа? Задайте свой вопрос!
            </h4>
            <form class="faq-form__form">
              <div class="faq-form__input">
                <input
                  type="text"
                  placeholder="Введите ваше имя"
                  v-model="name"
                />
              </div>
              <div class="faq-form__input">
                <input
                  type="text"
                  placeholder="Введите ваш телефон"
                  v-model="phone"
                />
              </div>
              <div class="faq-form__textarea">
                <textarea
                  placeholder="Задайте ваш вопрос"
                  v-model="comment"
                ></textarea>
              </div>
              <div class="faq-form__send">
                <button
                  class="faq-form__send-btn main-btn"
                  @click.prevent="send"
                >
                  Отправить
                </button>
                <Check />
              </div>
              <LoginHint />
            </form>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
import LoginHint from "~/components/UI/LoginHint.vue";
import Spoiler from "~/components/UI/Containers/Spoiler.vue";
import IconDef from "~/components/UI/IconDef.vue";
import Button from "~/components/UI/btn/Button.vue";
import Check from "~/components/UI/Form/Check.vue";
import api from "~/api/api.js";

const props = defineProps({
  items: {
    type: Array,
    default: () => [
      {
        id: 0,
        label: "Доставляете ли вы по России?",
        content: "Да, мы доставляем по всей стране через СДЭК",
      },
      {
        id: 1,
        label: "Если не подойдет размер?",
        content:
          "При покупке в интернет-магазине вы сможете произвести обмен или возврат в течение 7 дней, а приобретая в шоуруме — 14 дней.",
      },
      {
        id: 2,
        label: "Есть ли выездная примерка?",
        content:
          "Наш стилист может приехать к вам с выбранными вещами и провести примерку",
      },
      {
        id: 3,
        label: "Есть ли доставка курьером?",
        content:
          "Да, мы доставляем оплаченные заказы по Москве, стоимость доставки зависит от удаленности и объема отправления. Подробности Вы можете уточнить у нащего сотрудника по телефону или в Телеграм @blvka_store",
      },
      {
        id: 4,
        label: "Возможна ли покупка в рассрочку?",
        content:
          "Да, вы можете купить через сервис СПЛИТ. Просто выберете этот способ оплаты при заказе.",
      },
    ],
  },
});
let selectedSpoiler = ref(-1);
const changeSpoiler = (index) => {
  selectedSpoiler.value == index
    ? (selectedSpoiler.value = -1)
    : (selectedSpoiler.value = index);
};

const name = ref("");
const phone = ref("");
const comment = ref("");

async function send() {
  if (!name.value || !phone.value) {
    alert("Заполните имя и телефон");
    return;
  }

  const formData = new FormData();
  formData.append("name", name.value);
  formData.append("phone", phone.value);
  if (comment.value) formData.append("message", comment.value);
  formData.append("source", "faq");

  await api("/crm/leads/submit", formData, "POST");
  alert("Заявка отправлена");
  name.value = "";
  phone.value = "";
  comment.value = "";
}

onMounted(() => {});
</script>
